import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checkmark-empty",
  "use": "icon-checkmark-empty-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-checkmark-empty\">\n<circle cx=\"12\" cy=\"12\" r=\"12\" transform=\"rotate(90 12 12)\" fill=\"white\" />\n<path d=\"M12 15C13.864 15 15.375 13.489 15.375 11.625C15.375 9.76104 13.864 8.25 12 8.25C10.136 8.25 8.625 9.76104 8.625 11.625C8.625 13.489 10.136 15 12 15Z\" fill=\"#575E70\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol